import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  Table,
  Input,
  Label
} from "reactstrap";
import { connect } from "react-redux";
import { profilePicValidityCheck } from "../../../../utils/constants";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import { toastContainer } from "../../../../utils/toast";
import * as actionCreators from "../../../../modules/actions";
import EditActionRow from "./EditActionRow";
import { deepClone } from "../../../../utils/copyObject";

function ShareActionsModal({
  currentTrivia,
  open,
  onClose,
  updateTriviaObject,
  data,
  setCurrentTrivia
}) {
  const [actions, setActions] = useState([]);
  const [messageTitle,setMessageTitle] = useState("")

const modifyData=()=>{
  const insights=[...currentTrivia.surveyInsights.surveyQuestionsInsights]
  const surveyQuestionsInsights = insights.map(section => {
  
    const match = actions.find(m => m.parameter === section.heading);
  if (!match) return section;

  return {
    ...section,
    data: section.data.map(cat => ({
      ...cat,
     items: cat.items.map(item => {
             if ("enhanced" in item) {
                return {
                  ...item,
                  enhanced: item.enhanced === match.prevText ? match.action : item.enhanced,
              };
              }

              if("item" in item){
                return {
                  ...item,
                  item: item.item === match.prevText ? match.action : item.item,
              };
              }

            

  return item; // no enhanced key → return as is
})
    }))
  };
}); 


 const modifiedActions=actions.map(item=>{
  const {prevText,...rest}=item
  return{...rest}
})

  return {surveyQuestionsInsights,modifiedActions}
}

  const handleShareActions = () => {

    const {surveyQuestionsInsights,modifiedActions}=modifyData()
    const payload = {
      actions:modifiedActions,                            //actions,
      triviaName: currentTrivia.name,
      triviaId: currentTrivia._id,
      messageTitle
    };
    
     const newSurveyInsights = {
      ...currentTrivia.surveyInsights,
      surveyQuestionsInsights: surveyQuestionsInsights,
    }
   
    axios
      .post(url.shareSurveyInsightsActions, payload)
      .then(({ data }) => {
        if (data.data) {
          updateTriviaObject({
            selectedActions: data.data.selectedActions,
          });
          toastContainer("Shared successfully", "success");
          
       

          onClose();
        }
        axios
        .put(url.editTrivia(currentTrivia._id), {
          updateData: {
            selectedActions: modifiedActions,
            surveyInsights: newSurveyInsights,
          },
        }).then((response)=>{
          setCurrentTrivia({...response.data.data.trivia})
        })

      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.message
        ) {
          toastContainer(error.response.data.errors.message, "error");
        }
      });



  
  };

  useEffect(() => {
    if (
      data &&
      Array.isArray(data)
    ) { 
      const modifiedData=data.map(item=>({...item,prevText:item.action}))
      setActions(modifiedData);
    }
  }, [data]);

  useEffect(() => {
    if (
      data &&
      Array.isArray(data)
    ) {
      const modifiedData=data.map(item=>({...item,prevText:item.action}))
      setActions(modifiedData);
    }
  }, []);

  const handleActionUpdate = (value, index) => {
    const actionsArray = [...actions];


    actionsArray[index].action = value;
    actionsArray[index].lastUpdateActionText = new Date();


    setActions(actionsArray)
  
  };


  return (
    <Modal isOpen={open}>
      <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
        Share Outcomes
      </ModalHeader>

      <ModalBody >
        <div >
          <div className="my-2">
            <Label>Message title</Label>
            <Input value={messageTitle} onChange={e => setMessageTitle(e.target.value) } />
          </div>
          <div className="my-2">
            <Alert color="info">
            Outcomes will be shared via same method users received survey.
            </Alert>
          </div>
          <div className="my-1">
            <b>Outcomes:</b>
          </div>
          <div style={{maxHeight: 500, overflowY:'scroll',overflowX:'hidden'}}>
          <ul>
          {actions.filter(action=>action.action).map((item, index) => {
            return (
              <li className="my-1">
                <EditActionRow
                  index={index}
                  action={item.action}
                  handleSave={handleActionUpdate}
                  openTextArea
                />
              
              </li>
            );
          })}
          </ul>
          </div>
          
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose}>Cancel</Button>{" "}
        <Button
          color="success"
          disabled={
            currentTrivia.sharedWithUsers &&
            currentTrivia.sharedWithUsers.length == 0
          }
          onClick={handleShareActions}
        >
          Share
        </Button>
      </ModalFooter>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareActionsModal);
